<script>
import {defineComponent} from 'vue'
import ApiRequest from "@/core/api-request";
import Alert from "@/components/layout/Alert";

export default defineComponent({
  name: "FinishIndex",
  data() {
    return {
      search: '',
      search_timeout: null,
      loading: false,
      routes: [],
      selected_ids: [],
    }
  },
  computed: {
    all_selected() {
      return this.routes.length > 0 && this.routes.every((route) => this.selected_ids.includes(route.Route_Id));
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      ApiRequest.get({
        uri: '/routes',
        params: {search: this.search},
        loadingE: false
      }).then((res) => {
        this.loading = false;
        const data = res?.routes ?? res?.list ?? (Array.isArray(res) ? res : []);
        this.routes = data;
        // Bỏ chọn những xe không còn trong danh sách
        const ids = data.map((route) => route.Route_Id);
        this.selected_ids = this.selected_ids.filter((id) => ids.includes(id));
      }).catch((e) => {
        this.loading = false;
        console.error(e);
      });
    },
    onSearchChange() {
      if (this.search_timeout) {
        clearTimeout(this.search_timeout);
      }
      this.search_timeout = setTimeout(() => {
        this.fetch();
      }, 500);
    },
    isSelected(route) {
      return this.selected_ids.includes(route.Route_Id);
    },
    toggleRoute(route) {
      const index = this.selected_ids.indexOf(route.Route_Id);
      if (index > -1) {
        this.selected_ids.splice(index, 1);
      } else {
        this.selected_ids.push(route.Route_Id);
      }
    },
    toggleAll() {
      if (this.all_selected) {
        this.selected_ids = [];
      } else {
        this.selected_ids = this.routes.map((route) => route.Route_Id);
      }
    },
    formatDatetime(value) {
      if (!value) return '';
      const m = this.$moment(value);
      return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : value;
    },
    submit() {
      if (this.selected_ids.length === 0) {
        Alert.warning({message: 'Vui lòng chọn ít nhất 1 xe để Finish.'});
        return;
      }
      const total = this.selected_ids.length;
      ApiRequest.post({
        uri: '/routes/finish',
        data: {ids: [...this.selected_ids]}
      }).then(() => {
        Alert.success({message: 'Finish thành công ' + total + ' xe.'});
        this.selected_ids = [];
        this.fetch();
      }).catch((e) => {
        console.error(e);
      });
    }
  }
})
</script>

<template>
  <div class="px-4">
    <h4 class="text-orange">Finish Truck</h4>

    <div class="form-group mb-2">
      <label>Tìm kiếm xe</label>
      <input type="text" class="form-control" v-model="search" @input="onSearchChange"
             placeholder="Truck No">
    </div>

    <div class="d-flex align-items-center mb-2">
      <span class="text-muted">Tìm thấy <b>{{ routes.length }}</b> xe</span>
      <button class="btn btn-sm btn-link ml-auto" @click="toggleAll">
        {{ all_selected ? 'Bỏ chọn tất cả' : 'Chọn tất cả' }}
      </button>
    </div>

    <div v-if="loading" class="text-center text-muted py-4">Đang lấy dữ liệu...</div>
    <div v-else-if="routes.length === 0" class="text-center text-muted py-4">Không có dữ liệu</div>

    <div v-for="route in routes" :key="route.Route_Id"
         class="card route-card mb-2"
         :class="{'route-card--selected': isSelected(route)}"
         @click="toggleRoute(route)">
      <div class="card-body p-3">
        <div class="d-flex align-items-center">
          <h5 class="mb-0 text-orange">Xe <b>{{ route.TruckNo }}</b></h5>
          <div class="ml-auto">
            <i v-if="isSelected(route)" class="fas fa-2x fa-check-circle text-orange"></i>
            <i v-else class="fal fa-2x fa-circle text-secondary"></i>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap mt-1">
          <span class="badge badge-warning mr-1">{{ route.Route }}</span>
          <span class="badge badge-info">Seal: {{ route.SealNo || '--' }}</span>
        </div>

        <div class="mt-2 small">
          <span class="text-muted">DP:</span>
          <b>{{ formatDatetime(route.DP_Datetime) || '--' }}</b>
        </div>
      </div>
    </div>

    <div class="finish-bar py-2">
      <button class="btn btn-success w-100" :disabled="selected_ids.length === 0" @click="submit">
        Finish <template v-if="selected_ids.length">({{ selected_ids.length }})</template>
      </button>
    </div>
  </div>
</template>

<style scoped>
.route-card {
  cursor: pointer;
}

.route-card--selected {
  border-color: #F15A22;
  box-shadow: 0 0 0 1px #F15A22;
}

.finish-bar {
  position: sticky;
  bottom: 0;
  margin: 0 -1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  background-color: #fff;
}
</style>
